// extracted by mini-css-extract-plugin
export default {"container":"Rheology_container__pxK8C","creation_block":"Rheology_creation_block__+nht7"};